import { render, staticRenderFns } from "./user_new.vue?vue&type=template&id=7b199b18&scoped=true&"
import script from "./user_new.vue?vue&type=script&lang=js&"
export * from "./user_new.vue?vue&type=script&lang=js&"
import style0 from "./user_new.vue?vue&type=style&index=0&id=7b199b18&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b199b18",
  null
  
)

export default component.exports